import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { withTranslation } from 'react-i18next';

import "./ClaimConfirmModal.css"

class ClaimConfirmModal extends React.Component {
    render() {
        const { isOpen, onClose, onConfirm, t } = this.props;

        return (
            <div className="ClaimConfirmModal">
                <Modal isOpen={isOpen} toggle={onClose} className={this.props.className} contentClassName="modalCustomClass">
                    <ModalHeader toggle={onClose}>
                        {t('tasks.claim_modal.title')}
                    </ModalHeader>
                    <ModalBody>
                        {t('tasks.claim_modal.message')}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="info" onClick={onConfirm}>
                            <i className="fa fa-hand-rock-o"></i>&nbsp;
                            {t('tasks.claim')}
                        </Button>&nbsp;
                        <Button color="secondary" onClick={onClose}>
                            <i className="fa fa-close"></i>&nbsp;
                            {t('common.cancel')}
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default withTranslation("translations")(ClaimConfirmModal);
